import { render, staticRenderFns } from "./liked-prod.vue?vue&type=template&id=5b9b4ae0&scoped=true"
import script from "./liked-prod.vue?vue&type=script&lang=js"
export * from "./liked-prod.vue?vue&type=script&lang=js"
import style0 from "./liked-prod.vue?vue&type=style&index=0&id=5b9b4ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b4ae0",
  null
  
)

export default component.exports